import React, { useState } from 'react';
import { Check, Link2 } from 'lucide-react';
import { quizShareUrl, shareQuiz } from '../lib/share';

/** Botón para compartir el enlace de una trivia. Confirma en su sitio al copiar. */
export const ShareButton: React.FC<{
  quiz: { id: string; title: string };
  /** Con texto al lado del icono; si no, solo el icono. */
  withLabel?: boolean;
  className?: string;
}> = ({ quiz, withLabel = false, className = '' }) => {
  const [copiado, setCopiado] = useState(false);
  // El navegador puede negar el portapapeles (sin HTTPS, por permisos...).
  // Entonces se enseña el enlace ya seleccionado para copiarlo a mano, en vez
  // de un botón que no hace nada.
  const [aMano, setAMano] = useState(false);

  const compartir = async () => {
    const resultado = await shareQuiz(quiz);
    if (resultado === 'copied') {
      setCopiado(true);
      setTimeout(() => setCopiado(false), 1800);
    } else if (resultado === 'failed') {
      setAMano(true);
    }
  };

  const Icono = copiado ? Check : Link2;
  const texto = copiado ? 'Enlace copiado' : 'Compartir';

  return (
    <span className="relative flex shrink-0">
      <button
        onClick={() => void compartir()}
        aria-label={withLabel ? undefined : `Compartir enlace de ${quiz.title}`}
        title={copiado ? 'Enlace copiado' : 'Copiar enlace para compartir'}
        className={
          className ||
          `p-2 rounded-lg transition-colors ${
            copiado ? 'text-success-400' : 'text-ink-400 hover:text-ink-100 hover:bg-ink-800'
          }`
        }
      >
        <Icono className="w-4 h-4" />
        {withLabel && <span>{texto}</span>}
        {!withLabel && <span className="sr-only" aria-live="polite">{copiado ? 'Enlace copiado' : ''}</span>}
      </button>

      {aMano && (
        <input
          readOnly
          autoFocus
          value={quizShareUrl(quiz.id)}
          aria-label={`Enlace de ${quiz.title}`}
          onFocus={(e) => e.currentTarget.select()}
          onBlur={() => setAMano(false)}
          onKeyDown={(e) => e.key === 'Escape' && setAMano(false)}
          className="absolute right-0 bottom-full mb-2 z-20 w-72 max-w-[calc(100vw-2rem)] h-10 px-3 rounded-lg
                     bg-ink-850 border border-sky-500 text-ink-100 text-sm shadow-lg outline-none"
        />
      )}
    </span>
  );
};
